<template>
	<div class="management">
		<div class="management_title">
			<span class="management_title_setting" @click="WeathersClick()" :style="weatherstyle">气象站</span>
			<span class="management_title_reference" @click="FertilizerClick()" :style="fertilizerstyle">水肥机</span>
		</div>
		<draw1 v-if="isbool" />
		<draw2 v-if="!isbool" />
	</div>
</template>
<script setup>
	import draw1 from './draw1/index.vue'
	import draw2 from './draw2/index.vue'
	import button from '@/assets/home/button.png'
	import {
		ref,
		onMounted,
		reactive
	} from 'vue';
	//切换按钮
	let isbool = ref(true)
	//气象站切换按钮样式
	let weatherstyle = ref(`
	background-image: 
	url("${button}");
	background-size: 100% 100%;
	color: white;`)
	//水肥机切换按钮样式
	let fertilizerstyle = ref('color:#00a580')

	function WeathersClick() {
		isbool.value = true
		weatherstyle.value = `
		background-image: 
		url("${button}");
		background-size: 100% 100%;
		color: white;`
		fertilizerstyle.value = 'color:#00a580';
	}

	function FertilizerClick() {
		isbool.value = false
		weatherstyle.value = 'color:#00a580'
		fertilizerstyle.value = `
		background-image: 
		url("${button}");
		background-size: 100% 100%;
		color: white;`
	}
</script>



<style lang="scss">
	.management {
		height: 280px;
		width: 100%;

		span {
			display: inline-block;
		}
	}


	.management_title {
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		text-align: center;
		padding-left: 20px;

		span {
			width: 80px;
		}
	}
</style>